<template>
	<v-container class="ma-0 pa-0 terms_container" fill-height>
		<v-row dense class="ma-0 pa-0 px-7">
			<v-col cols="12" align-self="baseline" class="mt-13 mb-4 terms_selvy_title">
                <b>Selvy</b> Checkup
				<p class="user_terms_title_descript my-8">보험사 또는 보험 설계사에게 받은 직원코드를 입력해 주세요.</p>
				<input
					v-model.trim="customerCode"
					class="code_input"
					ref="customerCode"
					placeholder="직원코드를 입력해주세요."
					role="textbox"
					tabindex="1"
					@keydown.enter="goStart"
				/>
            </v-col>

			<v-col cols="12" align-self="center">
				<div class="terms_title">약관동의</div>
				<div class="terms_description">
                    본 서비스는 1회성으로 고객님의 정보를 저장하지 않습니다.
                </div>
				<div class="ck_u_all" style="border-bottom:1px solid #b4bcca;">
					<input
                        v-model="userInfo.isTermsAgreeAll"
                        type="checkbox"
                        id="termsAll"
                        class="terms_check"
						@click.stop="termsAgreeAll"
                    />
					<label
                        for="termsAll"
                        tabindex="2"
                        role="checkbox"
                        @keydown.enter="userInfo.isTermsAgreeAll = !userInfo.isTermsAgreeAll"
                    >
                        전체 동의하기
                    </label>
				</div>
				<div class="ck_u mt-5">
					<input
                        v-model="userInfo.isTermsAgree1"
                        type="checkbox"
                        id="terms1"
                        class="terms_check"
                    />
					<label
                        for="terms1"
                        tabindex="2"
                        role="checkbox"
                        @keydown.enter="userInfo.isTermsAgree1 = !userInfo.isTermsAgree1"
                    >
                        이용 약관 동의
                    </label>
					<span
                        class="privacy_link"
                        role="link"
                        tabindex="3"
                        @click="showPopup(1)"
                    >
                        보기
                    </span>
				</div>
				<div class="ck_u mt-5">
					<input
                        v-model="userInfo.isTermsAgree2"
                        type="checkbox"
                        id="terms2"
                        class="terms_check"
                    />
					<label
                        for="terms2"
                        tabindex="4"
                        role="checkbox"
                        @keydown.enter="userInfo.isTermsAgree2 = !userInfo.isTermsAgree2"
                    >
                        개인정보 수집 및 이용동의 (필수)
                    </label>
					<span
                        class="privacy_link"
                        tabindex="5"
                        role="link"
                        @click="showPopup(2)"
                    >
                        보기
                    </span>
				</div>
				<div class="ck_u mt-5">
					<input
                        v-model="userInfo.isTermsAgree3"
                        type="checkbox"
                        id="terms3"
                        class="terms_check"
                    />
					<label
                        for="terms3"
                        tabindex="6"
                        role="checkbox"
                        @keydown.enter="userInfo.isTermsAgree3 = !userInfo.isTermsAgree3"
                    >
                        민감정보 수집 및 이용동의 (필수)
                    </label>
					<span
                        class="privacy_link"
                        tabindex="7"
                        role="link"
                        @click="showPopup(3)"
                    >
                        보기
                    </span>
				</div>
				<div class="err_ly">
					<p
                        v-if="errorBag.name"
                        class="err_msg"
                    >
                        {{ errorBag.name[0] }}
                    </p>
				</div>
			</v-col>
		</v-row>

		<v-row dense class="ma-0 pa-0 px-7">
			
		</v-row>
		<!-- popup -->
		<VAccessPopup v-if="popupView1" @closePop="closePopup" />
		<VPersonalPopup v-if="popupView2" @closePop="closePopup" />
		<VSensitivePopup v-if="popupView3" @closePop="closePopup" />
        <VToast ref="toast" />
		<!-- // popup -->
		<v-container class="ma-0 pa-0 footer_btn_group">
			<v-row class="ma-0 pa-0">
				<v-col cols="3" align-self="end" class="ma-0 pa-0">
					<v-btn
						elevation="0"
						class="tearms_cancel_btn"
						block
						tabindex="8"
						@click="cancle"
						tile
						v-ripple
					>
						취소
					</v-btn>
				</v-col>
				<v-col cols="9" align-self="end" class="ma-0 pa-0">
					<v-btn
						elevation="0"
						block
						:class="this.enableButton ? 'tearms_start_enable_btn' : 'tearms_start_disable_btn'"
						:disabled="!this.enableButton"				tabindex="9"
						@click="goStart"
						tile
						v-ripple
					>
						시작하기
					</v-btn>
				</v-col>
			</v-row>
		</v-container>
	</v-container>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex'
	import VAccessPopup from "@/components/popup/accessTermsPopup.vue"
	import VPersonalPopup from "@/components/popup/personalTermsPopup.vue"
    import VSensitivePopup from "@/components/popup/sensitiveTermsPopup.vue"
    import VToast from "@/components/popup/toast.vue"
    import apiCaller from "@/utils/apiCaller"
    import sessionStorage from '@/utils/sessionStorage'

	export default {
		components: {
			VAccessPopup,
			VPersonalPopup,
            VSensitivePopup,
            VToast
		},

		data: () => ({
			userInfo: {
				isTermsAgree1: false,
				isTermsAgree2: false,
				isTermsAgree3: false
			},

			errorBag: {
				name: []
			},

			customerCode: "",

			popupView1: false,
			popupView2: false,
			popupView3: false,

			enableButton: false,

			prevScrollY: 0,
			errorMsg: '',
		}),
        computed: {
            ...mapGetters('user', [
                'getUser',
            ]),
        },
		methods: {
			...mapActions('user', [
                'logout',
				'signupWithCode',
                'getFcInfo',
				'setAuthToken',
                'setManagerCode',
                'setSiteId',
			]),
			...mapActions('survey', [
                'setStep',
                'clearCheckupTemp'
			]),

			// 공통 팝업 오픈
			showPopup(type) {
				this.prevScrollY = window.scrollY;
				window.scrollTo(0, 0);
				this[`popupView${type}`] = !this[`popupView${type}`];
			},
			// 공통 팝업 종료
			closePopup(type) {
				window.scrollTo(0, this.prevScrollY);
				this.prevScrollY = 0;
				this[`popupView${type}`] = !this[`popupView${type}`];
			},
			//취소
			cancle() {
				const pathType = sessionStorage.pathType.get('routePath')
				if (pathType) {
					this.$router.push(pathType)
				} else {
					this.$router.push('/Intro')
				}
			},
			//시작하기
			async goStart () {
                if (!this.customerCode.length > 0) {
                    return this.$refs.toast.open('직원코드를 입력해주세요.')
                } else if (
                    !this.userInfo.isTermsAgree1 ||
                    !this.userInfo.isTermsAgree2 ||
                    !this.userInfo.isTermsAgree3
                ) {
                    return this.$refs.toast.open('약관을 동의해주세요.')
                }

                const res = await this.signupWithCode(this.customerCode)
                const resultCode = Number(res.data.code)

				if(resultCode === 200) {
                    // 기존 정보 모두 삭제
                    this.logout()
                    this.clearCheckupTemp()

                    const param = {
                        authToken : res.data.result.token,
                        fcCode: this.customerCode
                    }
                    const res2 = await apiCaller.sign.getFCInfo(param)
                    if(Number(res2.data.code) === 200) {
                        this.setSiteId(res2.data.result.resEmployee.siteId)
                    }
					this.setAuthToken(res.data.result.token)
					this.setManagerCode(this.customerCode)
					this.setStep(1)
					this.$router.push(`/checkup/step1`)
				}
				else if(resultCode === 400) {
                    this.$refs.toast.open(this.$t('error.signin.invalidCode'))
				}
                else if(resultCode === 500) {
                    this.$refs.toast.open(this.$t('error.common.internalServer'))
                }
                else
                {
                    console.log(res)
                    this.$refs.toast.open(this.$t('error.common.unkonwn', resultCode))
				}
			},
			//버튼활성화
			buttonChange () {
				if (this.userInfo.isTermsAgree1 && this.userInfo.isTermsAgree2 && this.userInfo.isTermsAgree3 ) {
					this.userInfo.isTermsAgreeAll = true
				} else if (!this.userInfo.isTermsAgree1 || !this.userInfo.isTermsAgree2 || !this.userInfo.isTermsAgree3) {
					this.userInfo.isTermsAgreeAll = false
				}
				this.enableButton =
					this.customerCode.length > 0 &&
					this.userInfo.isTermsAgree1 &&
					this.userInfo.isTermsAgree2 &&
					this.userInfo.isTermsAgree3
			},
			termsAgreeAll () {
				if( !this.userInfo.isTermsAgree1 || !this.userInfo.isTermsAgree2 || !this.userInfo.isTermsAgree3) {
					this.userInfo.isTermsAgree1 = true
					this.userInfo.isTermsAgree2 = true
					this.userInfo.isTermsAgree3 = true
				} 
				
				else if (this.userInfo.isTermsAgree1 && this.userInfo.isTermsAgree2 && this.userInfo.isTermsAgree3 ){
					this.userInfo.isTermsAgree1 = false
					this.userInfo.isTermsAgree2 = false
					this.userInfo.isTermsAgree3 = false
				} 
			}
		},
		watch: {
			customerCode () {
				this.errorMsg = ''
				this.buttonChange()
			},
			'userInfo.isTermsAgree1' () {
				this.buttonChange()
			},
			'userInfo.isTermsAgree2' () {
				this.buttonChange()
			},
			'userInfo.isTermsAgree3' () {
				this.buttonChange()
			},
			'userInfo.isTermsAgreeAll' () {
				this.buttonChange()
			}
        },
        mounted() {
            window.scrollTo(0, 0)
        },
	};
</script>

<style scoped lang="scss">
	.terms_check {
		display: none;
		position: absolute;
		z-index: -1;
	}

	.terms_check + label {
		background: url(~@/assets/images/renew/ico-check-off.svg) no-repeat;
		display: inline-block;
		padding: 0 0 0 30px;
        cursor: pointer;
        height: 24px;
	}

	.terms_check:checked + label {
		background: url(~@/assets/images/renew/ico-check-on.svg) no-repeat;
		display: inline-block;
		padding: 0 0 0 30px;
		cursor: pointer;
	}

	.code_input {
		width: 100%;
		// max-width: 600px;
		height: 48px;
		border-radius: 4px;
		border:1px solid #efefef;
        font-family: NanumSquare, sans-serif;
		font-size: 18px;
		color: #202020;
		text-align: left;
		padding-left:10px;
	}

	.terms_title {
        font-family: NanumSquare, sans-serif;
        font-weight: bold;
		font-size: 14px;
        color: #193263;
	}

	.terms_description {
		word-break: keep-all;
        font-family: NanumSquare, sans-serif;
		font-size: 12px;
		color: #7584a1;
        margin-top: 8px;
        margin-bottom: 35px;
	}

	.ck_u {
        font-family: NanumSquare, sans-serif;
        font-size: 14px;
        color: #475b82;
        vertical-align: middle;
        line-height: 24px;
        position: relative;
	}

	.ck_u_all {
		font-family: NanumSquare, sans-serif;
        font-size: 16px;
		font-weight: 700;
        color: #475b82;
        height: 48px;
        vertical-align: middle;
        line-height: 24px;
        position: relative;
	}

	.privacy_link {
        font-family: NanumSquare, sans-serif;
        font-size: 14px;
        position: absolute;
		right: 0;
		color: #767676;
		text-decoration: underline;
	}

	.err_ly {
		margin-top: 2vh;
	}

	.err_msg {
        font-family: NanumSquare, sans-serif;
		font-size: 2vh;
		color: #ea5858;
		text-align: center;
	}

    .code_bg {
        background: url(~@/assets/images/code-bg.png) repeat;
        background-color: #3f6fff;
        background-size: 100%;
        padding: 5vh 7vw 7vh 7vw;
        text-align: center;
    }

	.tearms_cancel_btn {
		height: 60px !important;
		background-color: #dcdfe6 !important;
		color: #193263;
		font-weight: 700;
        font-family: NanumSquare, sans-serif !important;
	}

	.tearms_start_enable_btn {
		height: 60px !important;
		background-color: #193263 !important;
        font-family: NanumSquare, sans-serif;
        color: white !important;
		border: 0;
		outline: none;
	}

	.tearms_start_disable_btn {
		height: 60px !important;
		background-color: #193263 !important;
        font-family: NanumSquare, sans-serif !important;
        color: white !important;
		border: 0;
		outline: none;
    }
	::v-deep .theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
		background-color: #e6e8ee !important;
	}
	::v-deep .tearms_start_disable_btn .v-btn__content {
		color: white !important;
	}

	::v-deep .tearms_start_enable_btn .v-btn__content {
		color: white !important;
	}

	.terms_container {
		word-break: keep-all;
        align-items: baseline !important;
    }

	.user_terms_title_descript {
		font-size: 18px;
		color: #193263;
		line-height:26px;
		letter-spacing: -0.6px;
	}

	.terms_selvy_title {
		font-size: 15px;
		color: #193263;
	}

	button:disabled,
	button[disabled] {
		color: #ffffff !important;
		// background-color: #a7bdff !important;
		border: solid 0 #a7bdff !important;
	}
</style>
